import { render, staticRenderFns } from "./Champion.vue?vue&type=template&id=0bb5ad2a&scoped=true&"
import script from "./Champion.vue?vue&type=script&lang=js&"
export * from "./Champion.vue?vue&type=script&lang=js&"
import style0 from "./Champion.vue?vue&type=style&index=0&id=0bb5ad2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5ad2a",
  null
  
)

export default component.exports